import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { ClassAttributeType } from '../../../../../../api/types/settings/class-attributes/class-attribute-types';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const addClassAttributeToExistingListOperation = async (
  listId: number | undefined,
  attributeType: ClassAttributeType | null,
  attributeName: string,
  onHilde: () => any,
) => {
  try {
    if (!listId) {
      toast.warn(
        'לא ניתן לאתר את מזהה הרשימה, יש לנסות שוב בעוד מספר רגעים...',
      );
      return;
    }
    if (attributeName.length < 3 || attributeName.length > 60) {
      toast.warn('על שם התכונה להיות בעל שלוש תווים לפחות');
      return;
    }

    if (attributeType === null) {
      toast.warn('יש לבחור את הסוג התכונה');
      return;
    }

    await appApi.addClassAttributesToExistingList(
      listId,
      attributeName,
      attributeType,
    );
    globalSettingsStores.fetchSetting();
    onHilde();
  } catch (e) {
    toast.warn('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `addClassAttributeToExistingListOperation is failed with the listId: ${listId}, attributeType: ${attributeType}, attributeName: ${attributeName} with the error: ${e}`,
    );
  }
};
